export default "__VITE_ASSET__BoN0iZd3__"